import React from 'react';
import { useAppSelector } from '@hooks/redux-hooks';

const Level = ({ ...delegated }) => {
  const { currentLevel } = useAppSelector(s => s.levelling);
  return <span {...delegated}>{currentLevel}</span>;
};

export default Level;
